<template>
      <v-sheet class="transparent py-7">
        <v-card elevation="0">
          <v-card-text>
            <div class="mb-8">
              <h1 class="font-weight-black primary-color  display-1">Profile</h1>
              <h1 class="font-weight-black black--text mt-10" style="line-height : normal">{{user.name}}</h1>
              <p class="font-weight-bold m-0">{{user.role.name}}</p>
            </div>
            
            <v-row no-gutters>
              <v-col cols="12" sm="12" lg="4">
                <v-text-field light type="text" label="Name" v-model="data.name"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" lg="4">
                <v-text-field light type="email" label="Email" v-model="data.email"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" lg="4">
                <v-text-field label="Password" v-model="data.password" type="password" light counter @click:append="show = !show"></v-text-field>
              </v-col>
            </v-row>
            <div class="d-flex w-100 align-items-center justify-end mt-4">
              <v-btn @click="changeCredential(data)" x-large :loading="loader" class="primary-background text-end py-6" block elevation="6" dark>Update Data</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-sheet>
</template>

<script>
import axios from 'axios'
import { mapActions , mapGetters} from 'vuex'
import numeral from 'numeral'
export default {
  data () {
    return {
      data : {
        password : '',
        email : '',
        id : ''
      },
      show: false,
    }
  },
  mounted () {
      this.data.email = this.user.email
      this.data.name = this.user.name
      this.data.id = this.user.id
  },
  computed : {
    ...mapGetters({
      users : 'User/users',
      user : 'Auth/user',
      loader : 'Global/loader'
    })
  },  
  methods : {
    ...mapActions({
      getUser : 'User/getUser',
      sendReceipt : 'Forms/sendReceipt',
      changeCredential : 'Auth/changeCredential'
    }),
  }
}
</script>

<style>

</style>